import image from '../../images/logo-los-portales.png';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/firebase';
import userService from '../../services/user.service';
import StoreSelector from './StoreSelector';
import './Common.css';

export default function NavBar({ rolePermissions = {}, canManageCustomOrders = false }) {
    const {
        canViewCreate = false,
        canViewSearch = false,
        canViewBakers = false,
        canViewSettings = false,
        canViewMerchantOrders = false,
        canConsolidateOrders = false,
        canViewAnalytics = false,
        canViewJobApplications = false,
        canDesignToppers = false,
    } = rolePermissions || {};

    function handleSignOut() {
        userService.clearStoreOverride();
        localStorage.removeItem('selectedStoreId');
        signOut(auth);
    }

    return (
        <div>
            <nav>
                <div className="navbar-container">
                    <div className="nav-logo">
                        <img src={image} alt="Los Portales Logo" />
                    </div>
                    <StoreSelector />
                    <div className="nav-content">
                        <div className="nav-links">
                            {canViewCreate && (
                                <Link to='/' className="nav-link">Crear</Link>
                            )}
                            {canViewSearch && (
                                <Link to='/search' className="nav-link">Buscar</Link>
                            )}
                            {canViewBakers && (
                                <Link to="/panaderos" className="nav-link">Panaderos</Link>
                            )}
                            {canDesignToppers && (
                                <Link to="/topper" className="nav-link nav-link-pill">Toppers</Link>
                            )}
                            {canManageCustomOrders && (
                                <Link to="/custom-orders" className="nav-link nav-link-pill">Ordenes Especiales</Link>
                            )}
                            {canViewMerchantOrders && (
                                <Link to="/merchant-orders" className="nav-link nav-link-pill">Merchant Orders</Link>
                            )}
                            {canConsolidateOrders && (
                                <Link to="/product-catalog" className="nav-link nav-link-pill">Product Catalog</Link>
                            )}
                            {canConsolidateOrders && (
                                <Link to="/hq-consolidation" className="nav-link nav-link-pill">HQ Consolidation</Link>
                            )}
                            {canViewAnalytics && (
                                <Link to="/analytics" className="nav-link nav-link-pill">Analytics</Link>
                            )}
                            {canViewJobApplications && (
                                <Link to="/job-applications" className="nav-link nav-link-pill">Solicitudes</Link>
                            )}
                            {canViewSettings && (
                                <Link to="/settings" className="nav-link">Configuración</Link>
                            )}
                        </div>
                        <div className="nav-actions">
                            <button
                                className="signOutButton"
                                onClick={handleSignOut}
                            >
                                Cerrar Sesión
                            </button>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
}
